import React from 'react';
import {
  Flex,
  Heading,
  Text,
  Stack,
  useColorModeValue,
} from '@chakra-ui/react';
import { FeatureCardProps } from '../types';

const FeatureCardPresentation: React.FC<FeatureCardProps> = ({ 
  title, 
  text, 
  icon 
}) => {
  const bg = useColorModeValue('white', 'gray.700');
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  
  return (
    <Stack
      bg={bg}
      borderRadius="lg"
      borderWidth="1px"
      borderColor={borderColor}
      p={6}
      boxShadow="md"
      transition="all 0.3s"
      _hover={{
        transform: 'translateY(-5px)',
        boxShadow: 'lg',
      }}
    >
      <Flex
        w={16}
        h={16}
        align="center"
        justify="center"
        color="white"
        rounded="full"
        bg="brand.primary.base"
        mb={4}
      >
        {icon}
      </Flex>
      <Heading size="md" mb={2}>
        {title}
      </Heading>
      <Text color="gray.600">{text}</Text>
    </Stack>
  );
};

export default FeatureCardPresentation;